var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M1.93 5c-.515 0-.93.415-.93.93v11.098l5.938-6.301c.07-.077.166-.129.268-.146.154-.024.319.036.422.153l4.804 5.407 3.343-3.554c.07-.076.166-.128.269-.145.154-.024.318.035.421.152L21 17.654V5.93c0-.515-.415-.93-.93-.93H1.93zm10.698 3.256c.77 0 1.395.625 1.395 1.395s-.624 1.396-1.395 1.396c-.77 0-1.395-.625-1.395-1.396 0-.77.624-1.395 1.395-1.395zM7.272 11.73L1 18.38v.573c0 .516.415.93.93.93h12.587L7.272 11.73zm8.837 1.86l-3.06 3.249 2.711 3.045h4.31c.485 0 .879-.37.923-.843l-4.884-5.45z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImages);
export default __webpack_public_path__ + "static/media/icon-images.3a0ad2d4.svg";
export { ForwardRef as ReactComponent };